import React, { useState, useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  Paper,
  TextField,
  CircularProgress,
  Switch,
  FormControlLabel,
  MenuItem,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import Header from "../../DataLayouts/Header";
import toast from "react-hot-toast";
import useAuthStore from "../../../Zustand/Store/useAuthStore";
import axios from "axios";
import { MAIN_URL } from "../../../Configurations/Urls";
import { fetchPayrollComponentTypes, fetchPayrollLoanTypes } from "../../../Apis/Payroll";
import { fetchOrganizationEmployee } from "../../../Apis/Employee-api";

function PayrollLoanForm({ mode }) {
  const { id } = useParams();
  const { userData } = useAuthStore();
  const org = userData?.organization;

  const MAX_INCREMENT = 999999999.99;
  const [formData, setFormData] = useState({
    organization_person_id: "",
    advance_date: "",
    advance_amount: "",
    balance_amount: "",
    recovery_months: "",
    installment_amount: "",
    recovery_start_month: "",
    status: "",
    remarks: "",
  });

  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(mode === "edit");
  const [btnLoading, setbtnLoading] = useState(false);
  const [employee, setEmployee] = useState([]);
  const [loan, setLoanTypes]=useState([])
  let navigate = useNavigate();

  useEffect(() => {
    if (org?.organization_id) {
      fetchOrganizationEmployee(org.organization_id)
        .then((data) => {
          // fetchOrganizationEmployee already returns an array
          const employeeArray = Array.isArray(data) ? data : (data?.employees || data?.data || []);
          setEmployee(employeeArray);
          console.log("Employee data loaded:", employeeArray);
        })
        .catch((err) => {
          console.error("Error fetching employees:", err);
          setEmployee([]);
          toast.error(err.message || "Failed to fetch employee data");
        });
    }
  }, [org?.organization_id]);


    useEffect(() => {
    {
      fetchPayrollLoanTypes(org?.organization_id)
        .then((data) => {
          setLoanTypes(data?.payroll);
        })
        .catch((err) => {
          setFormErrors(err.message);
        });
    }
  }, []);
  useEffect(() => {
    let getdataById = async () => {
      const response = await axios.get(
        `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-loan/${id}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      let a = response?.data?.payroll;
      setFormData(a);
      setLoading(false);
    };
    if (mode === "edit" && id) {
      setLoading(true);
      getdataById();
    }
  }, [mode, id]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setFormErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const validateForm = () => {
    const errors = {};

    if (!formData.organization_person_id) errors.organization_person_id = "Employee is required.";

    if (!formData.loan_date)
      errors.loan_date = "Loan Date is required.";

    if (!formData.loan_amount)
      errors.loan_amount = "Loan Amount is required.";


     if (!formData.organization_payroll_loan_type_id )
      errors.organization_payroll_loan_type_id  = "Loan Type is required.";

    if (!formData.balance_amount)
      errors.balance_amount = "Balance Amount is required.";

    if (!formData.interest_rate)
      errors.interest_rate = "Rate of Interest is required.";

    if (!formData.status )
      errors.status  = "Status is  required.";

    if (!formData.emi_amount)
      errors.emi_amount = "Emi Amount is  required.";

    if (!formData.status) errors.status = "Status is required.";

    setFormErrors(errors);
    return Object.keys(errors)?.length === 0;
  };

  const handleSubmit = async () => {
    if (!validateForm()) return;
    setbtnLoading(true);

    try {
      if (mode === "edit") {
        await axios.put(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-loan/${id}`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      } else {
        await axios.post(
          `${MAIN_URL}/api/organizations/${org.organization_id}/payroll-loan`,
          formData,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("token")}`,
            },
          }
        );
      }
      toast.success(
        mode === "edit"
          ? "Payroll Loan updated!"
          : "Payroll Loan created!"
      );
      setFormErrors({});
      navigate(-1);
    } catch (err) {
      console.error(err);
      if (err.response?.status === 422) {
        const validationErrors = err.response.data.errors || {};
        setFormErrors(validationErrors);
        const errorMessages = Object.values(validationErrors)
          .map((arr) => arr[0])
          .join(" ");
        toast.error(errorMessages || "Validation failed.");
      } else {
        toast.error("Something went wrong.");
      }
    } finally {
      setbtnLoading(false);
    }
  };

  return (
    <Box px={4} py={4}>
      <Header
        mode={mode}
        updateMessage={"Payroll loans"}
        addMessage={"Payroll Loans"}
        homeLink={"/payroll/loans"}
        homeText={"Payroll Loans"}
      />
      {loading ? (
        <Grid container spacing={2}>
          <Box display="flex" justifyContent="center" py={4}>
            <CircularProgress />
          </Box>
        </Grid>
      ) : (
        <Grid container spacing={2}>
          <Grid item xs={12} md={8}>
            <Paper elevation={4} sx={{ p: 3 }}>
              <Grid container spacing={2}>
                <TextField
                  select
                  fullWidth
                  label="Person Name/ID"
                  name="organization_person_id"
                  value={formData?.organization_person_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_person_id}
                  helperText={formErrors.organization_person_id}
                  required
                >
                  {employee?.map((option) => {
                    const fullName =
                      `${option?.person_full_name || option?.name || ""} -- ${option?.person_code || option?.employee_code || option?.organization_person_id || ""}`.trim();
                    return (
                      <MenuItem
                        key={option?.organization_person_id}
                        value={option?.organization_person_id}
                      >
                        {fullName ? fullName : option?.organization_person_id}
                      </MenuItem>
                    );
                  })}
                </TextField>

                <TextField
                  select
                  fullWidth
                  label="Loan Type"
                  name="organization_payroll_loan_type_id"
                  value={formData.organization_payroll_loan_type_id}
                  onChange={handleChange}
                  error={!!formErrors.organization_payroll_loan_type_id}
                  helperText={formErrors.organization_payroll_loan_type_id}
                  required
                >
                  {loan?.map((option) => (
                    <MenuItem
                      key={option.organization_payroll_loan_type_id}
                      value={option.organization_payroll_loan_type_id}
                    >
                      {option?.loan_type_name}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  fullWidth
                  label="Loan Date"
                  name="loan_date"
                  type="date"
                  value={formData.loan_date}
                  onChange={handleChange}
                  error={!!formErrors.loan_date}
                  helperText={formErrors.loan_date}
                  required
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                <TextField
                  fullWidth
                  label="Loan Amount"
                  name="loan_amount"
                  type="number"
                  value={formData?.loan_amount}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= MAX_INCREMENT) {
                        handleChange(e);
                      } else {
                        e.target.value = MAX_INCREMENT;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.loan_amount}
                  helperText={formErrors.loan_amount}
                  required
                  inputProps={{
                    min: 0,
                    max: MAX_INCREMENT,
                    maxLength: 13,
                  }}
                />

                <TextField
                  fullWidth
                  label="Balance Amount"
                  name="balance_amount"
                  type="number"
                  value={formData?.balance_amount}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= MAX_INCREMENT) {
                        handleChange(e);
                      } else {
                        e.target.value = MAX_INCREMENT;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.balance_amount}
                  helperText={formErrors.balance_amount}
                  required
                  inputProps={{
                    min: 0,
                    max: MAX_INCREMENT,
                    maxLength: 13,
                  }}
                />

                <TextField
                  fullWidth
                  label="Interest Rate %"
                  name="interest_rate"
                  type="number"
                  value={formData?.interest_rate}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= MAX_INCREMENT) {
                        handleChange(e);
                      } else {
                        e.target.value = MAX_INCREMENT;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.interest_rate}
                  helperText={formErrors.interest_rate}
                  required
                  inputProps={{
                    min: 0,
                    max: MAX_INCREMENT,
                    maxLength: 13,
                  }}
                />

                <TextField
                  fullWidth
                  label="Emi Amount"
                  name="emi_amount"
                  type="number"
                  value={formData?.emi_amount}
                  onChange={(e) => {
                    let value = e.target.value;

                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= MAX_INCREMENT) {
                        handleChange(e);
                      } else {
                        e.target.value = MAX_INCREMENT;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.emi_amount}
                  helperText={formErrors.emi_amount}
                  
                  inputProps={{
                    min: 0,
                    max: MAX_INCREMENT,
                    maxLength: 13,
                  }}
                />

                <TextField
                  fullWidth
                  label="Total Installments"
                  name="total_installments"
                  type="number"
                  value={formData?.total_installments}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Allow only numbers or empty value
                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= 127) {
                        // tinyint signed max = 127
                        handleChange(e);
                      } else {
                        e.target.value = 127;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.total_installments}
                  helperText={formErrors.total_installments}
                  inputProps={{
                    min: 0,
                    max: 127,
                    maxLength: 3,
                  }}
                />

                <TextField
                  fullWidth
                  label="Installments Remaining"
                  name="installments_remaining"
                  type="number"
                  value={formData?.installments_remaining}
                  onChange={(e) => {
                    let value = e.target.value;

                    // Allow only numbers or empty value
                    if (/^\d*$/.test(value)) {
                      if (value === "" || Number(value) <= 127) {
                        // tinyint signed max = 127
                        handleChange(e);
                      } else {
                        e.target.value = 127;
                        handleChange(e);
                      }
                    }
                  }}
                  error={!!formErrors.installments_remaining}
                  helperText={formErrors.installments_remaining}
                  inputProps={{
                    min: 0,
                    max: 127,
                    maxLength: 3,
                  }}
                />

                <TextField
                  fullWidth
                  label="Replayment Start Date"
                  name="repayment_start_month"
                  type="date"
                  value={formData.repayment_start_month}
                  onChange={handleChange}
                  error={!!formErrors.repayment_start_month}
                  helperText={formErrors.repayment_start_month}
                  
                  InputLabelProps={{
                    shrink: true,
                  }}
                />

                <TextField
                  select
                  fullWidth
                  label="Status"
                  name="status"
                  value={formData.status}
                  onChange={handleChange}
                  error={!!formErrors.status}
                  helperText={formErrors.status}
                  required
                >
                  <MenuItem value="Requested">Requested</MenuItem>
                  <MenuItem value="Approved">Approved</MenuItem>
                  <MenuItem value="Rejected">Rejected</MenuItem>
                  <MenuItem value="Disbursed">Disbursed</MenuItem>
                  <MenuItem value="InRepayment">InRepayment</MenuItem>
                  <MenuItem value="Closed">Closed</MenuItem>
                  <MenuItem value="Cancelled">Cancelled</MenuItem>
                </TextField>

                <TextField
                  fullWidth
                  label="Remarks"
                  name="remarks"
                  value={formData.remarks}
                  onChange={handleChange}
                  error={!!formErrors.remarks}
                  helperText={formErrors.remarks}
                  inputProps={{ maxLength: 255 }}
                  multiline
                  rows={6}
                />

                <Button
                  variant="contained"
                  color="primary"
                  size="medium"
                  onClick={handleSubmit}
                  disabled={loading || btnLoading || mode === "view"}
                  sx={{
                    borderRadius: 2,
                    minWidth: 120,
                    textTransform: "capitalize",
                    fontWeight: 500,
                  }}
                >
                  {loading || btnLoading ? (
                    <CircularProgress size={22} sx={{ color: "#fff" }} />
                  ) : mode === "edit" ? (
                    "Submit"
                  ) : (
                    "Submit"
                  )}
                </Button>
              </Grid>

              {mode === "edit" && (
                <Grid item>
                  <Button
                    variant="contained"
                    color="primary"
                    size="medium"
                    onClick={() => navigate(-1)}
                    sx={{
                      borderRadius: 2,
                      minWidth: 120,
                      textTransform: "capitalize",
                      fontWeight: 500,
                      mt: 2,
                      backgroundColor: "#1976d2",
                      "&:hover": { backgroundColor: "#115293" },
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
              )}
            </Paper>
          </Grid>
        </Grid>
      )}
    </Box>
  );
}

export default PayrollLoanForm;
